import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PesapalService } from "src/app/services/pesapal.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-pesapal-pay",
  templateUrl: "./pesapal-pay.component.html",
  styleUrls: ["./pesapal-pay.component.css"],
})
export class PesapalPayComponent implements OnInit {
  constructor(private route: ActivatedRoute,private pesapal:PesapalService) {}
  error = ''
  success= ''
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const res = {
        pesapal_transaction_tracking_id:
          params["pesapal_transaction_tracking_id"],
        pesapal_merchant_reference: params["pesapal_merchant_reference"],
      };
      const token = params['token']

      this.pesapal.getPesapalUrl({token,res}).subscribe({
        next: (res) => {
          this.success='Payment has been verified. Redirecting to whatsapp'
          window.location.href = environment.whatsappRedirectURL},
        error: (err) => {
          this.error = err.message
        }
      })

    });
    
  }
}
